"use strict";
exports.__esModule = true;
exports.Thematic = void 0;
var Thematic;
(function (Thematic) {
    Thematic["Bank"] = "bank";
    Thematic["LetterPackage"] = "letter-package";
    Thematic["Dt"] = "dt";
    Thematic["Excellence"] = "excellence";
    Thematic["Innovation"] = "innovation";
    Thematic["International"] = "international";
    Thematic["Logistic"] = "logistic";
    Thematic["Medias"] = "medias";
    Thematic["Partnership"] = "partnership";
    Thematic["HumanResource"] = "human-resource";
    Thematic["HomeService"] = "home-service";
    Thematic["Telecom"] = "telecom";
    Thematic["Digital"] = "digital";
    Thematic["Ecology"] = "ecology";
})(Thematic = exports.Thematic || (exports.Thematic = {}));
//# sourceMappingURL=thematic.js.map